export default "__VITE_PUBLIC_ASSET__cc1d62b1__"